import React from "react";
import injectSheet from "react-jss";
import { Route, Switch } from "react-router-dom";
import { BottomNavHome, BottomNavProcess } from "../../";

const BottomNav = (props) => {
  const { classes, location } = props;

  const isHome = location.pathname === "/";

  return (
    <div className={`${classes.bottomContainer} ${isHome && "isHome"}`}>
      <Switch>
        <Route exact path="/" render={() => <BottomNavHome {...props} />} />
        <Route render={() => <BottomNavProcess {...props} />} />
      </Switch>
    </div>
  );
};

const styles = (theme) => ({
  bottomContainer: {
    position: "relative",
    backgroundColor: theme.colors.main,
    padding: `${theme.sizes.gutter / 2}px 0`,
    height: `${theme.sizes.footer}px`,
    [theme.media.medium]: {
      height: `${theme.sizes.footerLarge}px`,
    },
    transition: [
      {
        property: "height",
        duration: theme.speed.medium,
        timingFunction: theme.motion.deceleration,
      },
    ],
    "&.isHome": {
      height: `${theme.sizes.footerExpanded}px`,
      [theme.media.medium]: {
        height: `${theme.sizes.footerExpandedLarge}px`,
      },
    },
  },
});

export default injectSheet(styles)(BottomNav);



// WEBPACK FOOTER //
// ./src/modules/core/components/bottomNav.jsx